{
  "questions": {
    "culture": {
      "detailsPlaceholder": "<p>请用英文填写。例如：</p>\n<p>Whānau to be present, need interpreter, specific dietary customs</p>",
      "label": "您有任何文化或家庭方面的需求吗？",
      "nextLabel": "$t(common:next): <b>其他特殊需求或信息</b>",
      "title": "<h3>文化或家庭需求</h3>"
    },
    "language": {
      "de": "Deutsch / German",
      "detailsLabel": "您偏好的语言是什么？",
      "fj": "Vosa Vakaviti / Fijian",
      "fr": "Français / French",
      "ja": "日本語 / Japanese",
      "ko": "한국어 / Korean",
      "label": "您理解英语有困难吗？",
      "mi": "Te Reo Māori",
      "ms": "Malay / Malaysian",
      "nextLabel": "$t(common:next): <b>宗教或精神需求</b>",
      "other": "其他",
      "pt": "Português / Portuguese",
      "sm": "Gagana Samoa / Samoan",
      "ta": "தமிழ் / Tamil",
      "title": "<h3>理解英语</h3>",
      "tl": "Tagalog / Tagalog",
      "to": "Lea Faka-Tonga / Tongan",
      "zh": "简体中文 / Chinese"
    },
    "mobility": {
      "detailsPlaceholder": "请用英文填写。例如：<br/>使用助行器或轮椅；需要帮助上床",
      "label": "您是否有残疾，或在行动方面需要协助？",
      "nextLabel": "$t(common:next): <b>理解英文</b>",
      "title": "<h3>行动能力</h3>"
    },
    "other": {
      "detailsPlaceholder": "只需分享您认为相关的信息。这样有助于我们更好地为您提供支持。",
      "label": "您是否有其他特殊需求，或有其他信息希望我们了解？",
      "nextLabel": "$t(common:next): <b>领取您的肠道准备药物</b>",
      "title": "<h3>其他特殊需求或信息</h3>"
    },
    "prep": {
      "label": "请选择您希望接收的方式：",
      "nextLabel": "$t(common:next): <b>完成预约</b>",
      "pick-up-from-hospital": "<label>{{company}}</label>\n<p>在开放时间内请到接待处领取您的准备包。</p>",
      "pick-up-from-local-pharmacy": "<label>从您附近的药房领取</label>\n<p>我们会通过电子邮件发送处方，您可以带去药房。</p>",
      "receive-by-mail": "<label>通过邮寄接收</label>\n<p>我们会将您的准备包快递到您提供的住址。</p>",
      "text": "为准备您的手术，您需要服用一种可以清理肠道的特殊药物。",
      "title": "<h3>获取您的肠道准备药</h3><p>为准备您的手术，您需要服用一种可以清理肠道的特殊药物。</p>"
    },
    "religion": {
      "detailsPlaceholder": "<p>请用英语填写。例如：<br/>Quiet space for prayer, prefer same-gender staff for personal care</p>",
      "label": "您有任何宗教或精神方面的需求吗？",
      "nextLabel": "$t(common:next): <b>文化或家庭需求</b>",
      "title": "<h3>宗教或精神需求</h3>"
    }
  }
}
